// extracted by mini-css-extract-plugin
export default {"checkbox":"multipleChoiceFilter-module__checkbox__637d1","toggleButton":"multipleChoiceFilter-module__toggleButton__4RiT5"};